
import api from "../../../../../api/api"


const  serialize = (obj) =>{
    var str = [];
    for (var p in obj)
      if (obj.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      }
      console.log(str)
    return str.join("&");
}

const getList = (filter) =>{
    return new Promise((resolve, reject)=>{
        api.get("erp/voucher?"+serialize(filter)).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const getById = (id) =>{
    return new Promise((resolve, reject)=>{
        api.get("erp/voucher/"+id).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const getDraftList = (payload) =>{
    return new Promise((resolve, reject)=>{
        api.post("erp/voucher/draft",payload).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const save = (payload) =>{
    return new Promise((resolve, reject)=>{
        api.post("erp/voucher",payload).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const remove = (id) => {
    return new Promise((resolve, reject)=>{
        api.delete("erp/voucher/"+id).then( (res)=>{
            if(!res.data.error){
                resolve(res);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const syncTaxDetails = (payload) =>{
    return new Promise((resolve, reject)=>{
        api.post("erp/voucher/sync/tax-details",payload).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}


const salesFinalize = (id) =>{
    return new Promise((resolve, reject)=>{
        api.post("erp/sales-voucher-finalize/"+id).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const salesFinalizeDiscard = (id) =>{
    return new Promise((resolve, reject)=>{
        api.post("erp/sales-voucher-finalize/discard/"+id).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}


const purchaseFinalize = (id) =>{
    return new Promise((resolve, reject)=>{
        api.post("erp/purchase-voucher-finalize/"+id).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const purchaseFinalizeDiscard = (id) =>{
    return new Promise((resolve, reject)=>{
        api.post("erp/purchase-voucher-finalize/discard/"+id).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const paymentReceiptFinalize = (id) =>{
    return new Promise((resolve, reject)=>{
        api.post("erp/payment-receipt-finalize/"+id).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const paymentReceiptDiscard = (id) =>{
    return new Promise((resolve, reject)=>{
        api.post("erp/payment-receipt-finalize/discard/"+id).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const contraJournalFinalize = (id) =>{
    return new Promise((resolve, reject)=>{
        api.post("erp/contra-journal-finalize/"+id).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const contraJournalDiscard = (id) =>{
    return new Promise((resolve, reject)=>{
        api.post("erp/contra-journal-finalize/discard/"+id).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const cdNoteFinalize = (id) =>{
    return new Promise((resolve, reject)=>{
        api.post("erp/cd-note-finalize/"+id).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const cdNoteDiscard = (id) =>{
    return new Promise((resolve, reject)=>{
        api.post("erp/cd-note-finalize/discard/"+id).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const expenseFinalize = (id) =>{
    return new Promise((resolve, reject)=>{
        api.post("erp/expense-finalize/"+id).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const expenseDiscard = (id) =>{
    return new Promise((resolve, reject)=>{
        api.post("erp/expense-finalize/discard/"+id).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const voucherServices = {
    getList,
    getById,
    save,
    getDraftList,
    remove,
    syncTaxDetails,
    
    salesFinalize,
    salesFinalizeDiscard,
    purchaseFinalize,
    purchaseFinalizeDiscard,

    paymentReceiptFinalize,
    paymentReceiptDiscard,

    contraJournalFinalize,
    contraJournalDiscard,

    cdNoteFinalize,
    cdNoteDiscard,

    expenseFinalize,
    expenseDiscard,
    
}
export default voucherServices;